export default "__VITE_ASSET__CfziDjr9__"